import { useQuery } from '@tanstack/react-query';

import queryKeys from '@/configs/react-query-keys';
import service from '@/services/index';

export enum FeedbackListTarget {
  TOTAL = 'total',
  UNLINKED = 'unlinked',
}

type BaseProps = {
  topicAlias?: string;
  taxonomyAlias: string;
  enabled?: boolean;
};

const useFeedbackCountQuery = (props: BaseProps) => {
  const fetchCount = async () => {
    if (props.topicAlias)
      return await service.taxonomy.fetchTopicFeedbackCount(props.topicAlias);
    return await service.taxonomy.fetchTaxonomyFeedbackCount(
      props.taxonomyAlias,
    );
  };
  return useQuery({
    queryKey: [
      queryKeys.taxonomy.TOPIC_DETAIL_FEEDBACK_COUNT,
      props.taxonomyAlias,
      props.topicAlias,
    ],
    queryFn: fetchCount,
    enabled: props.enabled,
  });
};

const useUnlinkedFeedbackCountQuery = (props: BaseProps) => {
  const fetchCount = async () => {
    if (props.topicAlias)
      return await service.taxonomy.fetchTopicUnclassifiedFeedbackCount(
        props.topicAlias,
      );

    return await service.taxonomy.fetchTaxonomyUnclassifiedFeedbackCount(
      props.taxonomyAlias,
    );
  };
  return useQuery({
    queryKey: [
      queryKeys.taxonomy.TOPIC_DETAIL_UNLINKED_FEEDBACK_COUNT,
      props.taxonomyAlias,
      props.topicAlias,
    ],
    queryFn: fetchCount,
    enabled: props.enabled,
  });
};

const useTopicDetailQuery = (props: BaseProps) => {
  const { topicAlias } = props;
  return useQuery({
    queryKey: [...queryKeys.taxonomy.TOPIC_DETAIL, topicAlias],
    queryFn: async () => {
      if (!topicAlias) {
        throw new Error('Topic alias is required');
      }

      return await service.taxonomy.fetchTopicDetail(topicAlias);
    },
    enabled: Boolean(props.enabled && topicAlias),
  });
};

export default {
  useFeedbackCountQuery,
  useUnlinkedFeedbackCountQuery,
  useTopicDetailQuery,
};
